module.exports = __webpack_public_path__ + "img/fa-store.9a4fe420.svg";